import { ISuperadmin } from "../../components/UserContext";
import { Api_Response, GET, POST } from "../base-services";

export class Superadmin_Service {
    static url = "/superadmin";

    static async login_superadmin(creds: {
        username: string;
        password: string;
    }) {
        return POST<Login_Superadmin_Response>(
            `${Superadmin_Service.url}/login`,
            creds
        );
    }

    static async is_logged() {
        return GET<Is_Logged_Response>(`${Superadmin_Service.url}/is-logged`);
    }

    static async logout() {
        return POST<Logout_Response>(`${Superadmin_Service.url}/logout`);
    }
}

type Login_Superadmin_Response = Api_Response<{
    message: string;
    admin: ISuperadmin;
}>;

type Is_Logged_Response = Api_Response<{
    message: string;
    admin: ISuperadmin;
}>;

type Logout_Response = Api_Response<{ message: string }>;
